import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {ApiErrors, StoreLoadingEnum} from 'types/global';
import {createApiError} from 'helpers/global';
import {RootState} from "store";
import {TeamsDto, TeamsQueryParams} from 'types/teams';
import {teamsApi} from "../api/teams";

interface NotificationsTeamsDto {
    loading: StoreLoadingEnum;
    error: string | null;
    data: TeamsDto | null;
}

const initialState: NotificationsTeamsDto = {
    loading: StoreLoadingEnum.idle,
    error: null,
    data: null,
}
export const teamsThunk = createAsyncThunk<
    TeamsDto,
    TeamsQueryParams & { signal?: AbortSignal },
    { rejectValue: ApiErrors }
>(
    'teams/get',
    async (data, thunkAPI) => {
        try {
            return await teamsApi.getTeams(data, data.signal);
        } catch (e) {
            if (e.name === 'AbortError' || e.code === 'ERR_CANCELED') {
                return thunkAPI.rejectWithValue({message: 'canceled'});
            }
            return thunkAPI.rejectWithValue(createApiError(e));
        }
    }
);

export const teamsSlice = createSlice({
    name: 'teams',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(teamsThunk.pending, (state) => {
            state.data = null;
            state.loading = StoreLoadingEnum.pending;
            state.error = null;
        });
        builder.addCase(teamsThunk.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = StoreLoadingEnum.loaded;
            state.error = null;
        });
        builder.addCase(teamsThunk.rejected, (state, action) => {
            if (!action.payload || action.payload.message === 'canceled') return;

            state.data = null;
            state.loading = StoreLoadingEnum.loaded;
            state.error = action.payload?.message || null;
        });
    },
});

export const selectTeamsDataSelector = (state: RootState) => state.teams.data?.content;
export const selectTeamsLoadingSelector = (state: RootState) => state.teams.loading;
export const currentOffsetSelector = (state: RootState) => state.teams.data?.pageable.offset ?? 0;
export const totalElementsSelector = (state: RootState) => state.teams.data?.totalElements ?? 0;
export const currentPageSizeSelector = (state: RootState) => state.teams.data?.pageable.pageSize ?? 0;